export const removeAuthToken = (): void => {
  localStorage.removeItem('access_token');
};
